<template>
    <div class="app-inner">
         <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            返回
            </div>
            </div>
               <div v-html="list.content" v-if="list.content" class="nr" id="nr"></div>
                <div v-else class="flex align-cen emtey">
                <div>
                    <i class="icon-al-cry-fill"></i>
                    <p>暂无内容，请先上传课件</p>
                </div>
            </div>
    </div>
</template>
<script>
import {courseChapterDetail} from "@/api/index/index"  //获取课程章节详情
export default {
    name:'courseVideo',
    data () {
        return {
            list:{}
        }
    },
    created () {
        this.getInfo()
    },
    mounted(){  
    },
    methods: {
        getInfo(){
            courseChapterDetail({id:this.$route.query.chapterId},'get')
            .then(res =>{
               this.list= res.data
            })
        },
        // 返回
        reback(){
            this.$router.push(
                {
                    name:'previewCourseDetail',
                    query:{
                        id:this.$route.query.id,
                        currentNav1:this.$route.query.currentNav1
                    }
                }
            )
        },
    },
}
</script>
<style lang="scss" scoped>
 .nr{
            width: 70%;
            margin: 0 auto;
            margin-top: 20px;
            height: calc(100% - 60px);
            overflow: auto;
          -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
        }
  .emtey{
            justify-content: center;
            text-align: center;
            padding-top: 20vh;
             color: #ccc;
            i{
                font-size: 50px;
                color: #ccc;
                
            }
        }
</style>